import {
  IResearchClientProgress,
  IResearchWorkFilters,
} from "features/Research/types";
import { apiClient } from "lib/apiClient";

export type IResearchClientProgressFilters = Pick<
  IResearchWorkFilters,
  "clientCompanyId" | "workType" | "dueFrom" | "dueTo" | "search"
>;

export const getResearchClientProgress = async (
  filters: IResearchClientProgressFilters
): Promise<IResearchClientProgress[]> => {
  const response = await apiClient.get("/research/client-progress", {
    params: filters,
  });

  return response.data;
};
